<template>
	<ul class="v-resume-about-me">
		<li 
			:key="`resume_about_me_${item.id}`"
			class="v-resume-about-me__item"
			:class="{'v-resume-about-me__item--hidden': !item.text}"
			v-for="item in list">
			<v-resume-title size="4" :title="item.title" class="v-resume-about-me__title" />
			<v-resume-text :text="item.text" class="v-resume-about-me__text" :isLinkify="isLinkify" />
		</li>
	</ul>
</template>
<script>
import VResumeTitle from '@/components_new/b2c/vresume-title/index'
import VResumeText from '@/components_new/b2c/vresume-text/index'
export default {
	components: {
		VResumeText,
		VResumeTitle
	},
	props: {
		list: Array,
		isLinkify: Boolean
	}
}
</script>
<style lang="scss" scoped>
.v-resume-about-me {
	padding: 0;
	list-style-type: none;

	&__item {
		&--hidden {
			display: none;
		}
	}

	::v-deep
	&__title {
		margin-bottom: 12px;
	}

	&__text {
		margin-bottom: 20px;
	}
}
</style>